import AxiosService from './AxiosService'

class TokenProfileRestService {
  get(): Promise<any> {
    return AxiosService.get('/tokenprofiles')
  }

  getAllConfigurable(): Promise<any> {
    return AxiosService.get('/tokenprofiles/configurable')
  }

  getById(id: number): Promise<any> {
    return AxiosService.get('/tokenprofiles/' + id)
  }

  create(tokenProfile: any, forceUpdate: boolean): Promise<any> {
    return AxiosService.post(forceUpdate ? '/tokenprofiles?force=true' : '/tokenprofiles', tokenProfile)
  }

  delete(id: any): Promise<any> {
    return AxiosService.delete('/tokenprofiles/' + id)
  }

  getDefinitions(): Promise<any> {
    return AxiosService.get('/tokenprofiles/definitions')
  }
}

export default new TokenProfileRestService()
